<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">상품 관리</a> &gt; <strong>부고장 리스트</strong></div>
			<h2 class="h_sub">부고장 리스트</h2>
		</div>

    <InvitationFuneralListForm/>
  </div>
</template>

<script>
import InvitationFuneralListForm from '@/components/admin/product/InvitationFuneralListForm.vue';

export default {
  components: {
    InvitationFuneralListForm
  }    
}
</script>
<style lang="">
    
</style>